<template>
  <transition name="el-fade-in-linear">
    <div class="layout_left_nav_menu" id="leftNavMenu" v-if="$_isOpenLeftMenu">
      <div class="item_list">
        <ul>
          <router-link to="/task" tag="li" class="item">
            <i :class="['iconfont', 'icon-renwu','item_icon']"></i>
            <span class="item_name">任务管理</span>
          </router-link>
          <router-link to="/achievement" tag="li" class="item">
            <i :class="['iconfont', 'icon-chengguo','item_icon']"></i>
            <span class="item_name">成果管理</span>
          </router-link>
          <router-link to="/academic-meeting" tag="li" class="item">
            <i :class="['iconfont', 'icon-huiyi','item_icon']"></i>
            <span class="item_name">学术会议</span>
          </router-link>
          <router-link to="/project" tag="li" class="item">
            <i :class="['iconfont', 'icon-xiangmu','item_icon']"></i>
            <span class="item_name">项目管理</span>
          </router-link>
          <!-- <router-link to="/team" tag="li" class="item">
            <i :class="['iconfont', 'icon-tuanduimokuai','item_icon']"></i>
            <span class="item_name">团队管理</span>
          </router-link> -->
          <router-link to="/data" tag="li" class="item">
            <i :class="['iconfont', 'icon-shujufuwu','item_icon']"></i>
            <span class="item_name">数据服务</span>
          </router-link>
          <!-- <router-link to="/company" tag="li" class="item">
            <i :class="['iconfont', 'icon-qiye','item_icon']"></i>
            <span class="item_name">企业模块</span>
          </router-link> -->
          <li class="item" @click="checkIJournal('/xueshi-iJournal/home')">
            <i :class="['iconfont', 'icon-qikanchaxun','item_icon']"></i>
            <span class="item_name">期刊查询</span>
          </li>
        </ul>
      </div>
      <!-- 当时为了引导页，特意把右边的菜单块和左边遮罩块拆分开来 -->
      <div class="item_list_container" @click="$_isOpenLeftMenu = false"></div>
      <i-journal-dialog :visible.sync="iJournalDialogVisibile" @login="token =>afterGetToken(iJournalDialogPath, token)"></i-journal-dialog>
    </div>
  </transition>
</template>

<script>
import * as api from '~/api'
import iJournalDialog from '~/views/console/ijournal-dialog'

export default {
  data () {
    return {
      // 第一次使用iJournal
      iJournalDialogVisibile: false,
      iJournalDialogPath: ''
    }
  },
  props: {
    isOpenLeftMenu: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    $_isOpenLeftMenu: {
      get () {
        return this.isOpenLeftMenu
      },
      set (val) {
        this.$emit('update:isOpenLeftMenu', val)
      }
    },
    // 是否绑定了iJournal
    isIJournalBinded () {
      return this.$store.state.userInfo.binds.ijournal || false
    }
  },
  components: {
    iJournalDialog
  },
  methods: {
    checkIJournal (path) {
      if (this.isIJournalBinded) {
        api.iJournalLogin().then(res => {
          if (res.data.code === 0) {
            this.afterGetToken(path, res.data.data.token)
          }
        }).catch(err => {
          this.$message.error('网络错误，请重试！')
          console.log(err)
        })
      } else {
        this.iJournalDialogVisibile = true
        this.iJournalDialogPath = path
      }
    },
    afterGetToken (path, token) {
      this.$router.push({
        path: path,
        query: {
          token: token
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout_left_nav_menu {
  position: absolute;
  top: $layout-header-height;
  bottom: 0;
  left: 0;
  width: $container-sidebar-width;
  z-index: 1990;
  .item_list {
    width: $container-sidebar-width;
    height: 100%;
    background-color: #ffffff;
  }
  .item {
    width: $container-sidebar-width;
    overflow: hidden;
    height: 50px;
    display: flex;
    align-items: center;
    &:hover {
      cursor: pointer;
      background-color: #EBF3FF;
      .item_icon, .item_name {
        color: $color-primary;
      }
    }
    &_icon {
      display: inline-block;
      padding: 17px;
      color: $color-text-primary;
    }
    &_name {
      display: inline-block;
      color: $color-text-regular;
      width: 130px;
      padding: 0 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .item_list_container {
    position: fixed;
    top: $layout-header-height;
    bottom: 0;
    left: $container-sidebar-width;
    right: 0;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/aside/index.vue